import React from "react";
import style from "./About.module.css";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import OurTeam from "../../components/About/OurTeam/OurTeam";
import img1 from "../../assets/img1.png";
import img2 from "../../assets/img2.png";
import downArrow from "../../assets/downArrow.png";

import { leadershipData } from "utils/consts";

const mainLeaders = leadershipData.filter(
  (leader) => leader.type === "main"
);

function About() {
  return (
    <div className={style.wrapper}>
      <div className={style.container}>
        <Grid
          container
          spacing={3}
          alignItems="center"
          sx={{ marginTop: { xs: 1, md: 6 } }}>
          <Grid item md={7} xs={12}>
            <Typography
              fontFamily="Inter"
              fontSize="15px"
              color="#FFC700"
              marginBottom="25px">
              About us
            </Typography>
            <Typography
              fontFamily="Inter"
              sx={{
                fontSize: {
                  xs: "32px",
                  sm: "40px",
                  md: "50px",
                },
              }}
              fontWeight="500"
              maxWidth="568px"
              textAlign="left">
              Innovating Today's Technology Landscape
            </Typography>
          </Grid>
          <Grid
            item
            md={5}
            xs={12}
            sx={{
              marginTop: {
                xs: "15px",
                sm: "15px",
                md: "60px",
              },
            }}>
            <Typography
              fontFamily="Inter"
              fontSize="14px"
              fontWeight="400"
              maxWidth="366px"
              textAlign="left">
              MSigma Infotech pioneers today's tech innovation, forging
              solutions that redefine industries and shape tomorrow's
              technological landscape.
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={3} marginTop="60px">
          <Grid item md={7} xs={12}>
            <img
              style={{ objectFit: "cover" }}
              src={img1}
              alt=""
              width="98%"
              height="400px"
            />
          </Grid>
          <Grid item md={5} xs={12}>
            <img
              style={{ objectFit: "cover" }}
              src={img2}
              alt=""
              width="98%"
              height="400px"
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} marginTop="60px">
          <Grid item md={7} xs={12}>
            <Typography
              fontFamily="Inter"
              fontSize="32px"
              fontWeight="300"
              textTransform="uppercase">
              Our Story
              <span style={{ marginLeft: "10px" }}>
                <img src={downArrow} />
              </span>
            </Typography>
          </Grid>
          <Grid item md={5} xs={12}>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  fontFamily="Inter"
                  fontWeight="600"
                  color="#171717"
                  marginBottom="30px"
                  lineHeight="190%"
                  sx={{
                    fontSize: {
                      xs: "17px",
                      sm: "19px",
                      md: "20px",
                    },
                  }}>
                  We have helped clients in diverse industries - from school and
                  colleges to hospitals, Ed-tech companies and logistics
                  providers - with their digital transformations, product
                  development, business modernization needs and challenges.
                </Typography>
                {/* <Typography
                  fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="#535353"
                  marginBottom="30px"
                  lineHeight="190%"
                >
                  It is a long established fact that a reader will be distracted
                  by the readable content of a page when looking at its layout.
                  The point of using Lorem Ipsum is that it has a more-or-less
                  normal distribution of letters, as opposed to using 'Content
                  here, content here', making it look like readable English.
                </Typography> */}
                {/* <Typography
                  fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="#535353"
                  lineHeight="190%"
                >
                  Many desktop publishing packages and web page editors now use
                  Lorem Ipsum as their default model text, and a search for
                  'lorem ipsum' will uncover many web sites still in their
                  infancy. Various versions have evolved over the years,
                  sometimes by accident, sometimes on purpose (injected humour
                  and the like).
                </Typography> */}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container marginTop="100px">
          {mainLeaders.map((leader, index) => (
            <Grid item xs={12} key={index}>
              <Typography
                fontFamily="Inter"
                fontSize="32px"
                fontWeight="300"
                textTransform="uppercase"
                borderBottom="1px solid #D9D9D9"
                paddingBottom="24px">
                <span style={{ color: "#FFE000" }}>/ </span>Our {leader.role}
              </Typography>
              <Card
                sx={{ minWidth: 275, boxShadow: "none", marginTop: "30px" }}>
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item md={4} xs={12}>
                      <img src={leader.image} alt="" width="95%" />
                    </Grid>
                    <Grid item md={8} xs={12}>
                      <Grid container>
                        <Grid item xs={12}>
                          <Typography
                            fontFamily="Inter"
                            fontSize="20px"
                            fontWeight="600"
                            marginBottom="25px">
                            {leader.name}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography
                            fontFamily="Inter"
                            fontSize="16px"
                            fontWeight="400"
                            color="#535353"
                            lineHeight="190%"
                            marginBottom="25px"
                            dangerouslySetInnerHTML={{
                              __html: leader.para1,
                            }}
                          />
                          <Typography
                            fontFamily="Inter"
                            fontSize="16px"
                            fontWeight="400"
                            color="#535353"
                            lineHeight="190%"
                            marginBottom="25px"
                            dangerouslySetInnerHTML={{
                              __html: leader.para2,
                            }}
                          />
                          <Typography
                            fontFamily="Inter"
                            fontSize="16px"
                            fontWeight="400"
                            color="#535353"
                            lineHeight="190%"
                            dangerouslySetInnerHTML={{
                              __html: leader.para3,
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <OurTeam />
      </div>
    </div>
  );
}

export default About;
